import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Badge } from "@/components/ui/badge";
import { getErrorMessage } from "@/lib/errors";

export default function SystemHealth() {
  const [health, setHealth] = useState(null);

  useEffect(() => { api.get("/admin/health").then(({ data }) => setHealth(data)).catch((err) => toast.error(getErrorMessage(err))); }, []);

  if (!health) return <p className="text-sm text-muted-foreground">Loading…</p>;

  return (
    <div className="space-y-6" data-testid="system-health-page">
      <PageHeader title="Backup & Health" description="Database connectivity, latest migration and background scheduler status." />
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-border bg-card p-5" data-testid="health-db-card">
          <div className="flex items-center gap-2">
            {health.db_connection_ok ? <CheckCircle2 className="h-5 w-5 text-emerald-500" /> : <XCircle className="h-5 w-5 text-rose-500" />}
            <p className="text-sm font-semibold text-foreground">Database Connection</p>
          </div>
          <p className="mt-1 text-xs text-muted-foreground">{health.db_connection_ok ? "Connected" : "Not connected"}</p>
        </div>
        <div className="rounded-xl border border-border bg-card p-5" data-testid="health-migration-card">
          <p className="text-sm font-semibold text-foreground">Last Migration</p>
          <p className="mt-1 font-mono text-xs text-muted-foreground">{health.last_migration || "—"}</p>
        </div>
        <div className="rounded-xl border border-border bg-card p-5" data-testid="health-scheduler-card">
          <p className="text-sm font-semibold text-foreground">Background Scheduler</p>
          <Badge className="mt-2" variant={health.scheduler_enabled ? "default" : "secondary"}>{health.scheduler_enabled ? "Enabled" : "Disabled"}</Badge>
        </div>
        <div className="rounded-xl border border-border bg-card p-5" data-testid="health-snapshot-card">
          <p className="text-sm font-semibold text-foreground">Last Snapshot</p>
          <p className="mt-1 text-xs text-muted-foreground">{health.last_snapshot_at || "No snapshots recorded"}</p>
        </div>
      </div>
    </div>
  );
}
